import { observer } from 'mobx-react-lite';
import { useResolve } from '@/tsyringe-hooks/useResolve';
import { AvailableModalDialogs, ModalDialogStore, TOKEN_ModalDialogStore } from './ModalDialogStore';

import {
    ControlledDialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription
} from '@/components/ui/dialog';
import { LoadingScreen } from '@/components/LoadingScreen';
import RunningActionStore, { TOKEN_RunningActionStore } from '../utility-stores/RunningActionStore';
import ShareLinkView from './ShareLinkView';
import UsersDialogView from './UsersDialogView';
import ShareLinksDialogView from './ShareLinksDialogView';

const ModalDialog = observer(() => {
    const modalDialogStore = useResolve<ModalDialogStore>(TOKEN_ModalDialogStore);
    const runningActionStore = useResolve<RunningActionStore>(TOKEN_RunningActionStore);

    return <ControlledDialog
        open={modalDialogStore.isOpen}
        onOpenChange={modalDialogStore.onOpenChange}
    >
        <DialogContent className="max-h-[80vh] flex flex-col" onClose={modalDialogStore.onClose}>
            {!runningActionStore.isRunningBlockingAction && <DialogHeader>
                <DialogTitle>{modalDialogStore.dialogTitle}</DialogTitle>
                {modalDialogStore.dialogDescription && <DialogDescription>
                    {modalDialogStore.dialogDescription}
                </DialogDescription>}
            </DialogHeader>}

            <div className="overflow-y-auto flex-grow">
                {runningActionStore.isRunningBlockingAction && modalDialogStore.isOpen &&
                    <div className="h-96">
                        <LoadingScreen message={runningActionStore.message} />
                    </div>}

                {!runningActionStore.isRunningBlockingAction && modalDialogStore.currentDialog === AvailableModalDialogs.CreateShareLink &&
                    <ShareLinkView />}

                {!runningActionStore.isRunningBlockingAction && modalDialogStore.currentDialog === AvailableModalDialogs.ViewAccessList &&
                    <UsersDialogView />}

                {!runningActionStore.isRunningBlockingAction && modalDialogStore.currentDialog === AvailableModalDialogs.ShareLinksList &&
                    <ShareLinksDialogView />}
            </div>

        </DialogContent>
    </ControlledDialog>
});

export default ModalDialog;